import { PlanMetrics, mapToOrgPlanTracker, mapToPlanMetrics } from '../models/plan-metrics.model';

import { clearToast, hideToast, setPlans, updateAllOrganizations, updateAllUsers, updateIsLoading, updateISNewOrganization, updateLoadingSecureDocs, updateMenuFlag, updateOrgPlanMetrics, updatePlanDetails, updatePlanMetrics, updateSecureDocs, updateSecureDocsStatusModel, updateSmsNotificationStatus, updateUserPlanMetrics, updateUserRoleId, updateUsers } from '../reducers/reducer';
import { SecureDocsService } from '../services/SecureDocsService';
import { mapToSecureDoc } from '../models/secure-docs.model';
import { UserService } from '../services/UserService';
import { mapToChannelUser, mapToOrganizationModel, } from '../models/users.model';
import { mapToNeWPlanModel, mapToUserPlanModel, PlanStatus } from '../models/plan.model';
import { getAllPlans } from '../services/PlanService';
import { SysAdminService } from '../services/sysAdminService';

export const SetUserRoleId = (dispatch: any, id: number) => {
    dispatch(updateUserRoleId(id))
}

export const UpdateUser = (dispatch: any, id: number) => {
    dispatch(updateUserRoleId(id))
}

export const UpdateMenuFlag = (dispatch: any, flag: boolean) => {
    dispatch(updateMenuFlag(flag))
}

export const UpdatePlanMetrics = (dispatch: any, data: PlanMetrics) => {
    dispatch(updatePlanMetrics(mapToPlanMetrics(data)));
}

export const LoadSettings = (dispatch: any) => {
    // return SettingsService.getAllSettings().then((res: any) => {
    //     dispatch(updateSettings(res.map(mapToSetting)))
    // })
}

export const UpdateuserPlanTracker = (dispatch: any, data: any) => {
    dispatch(updateUserPlanMetrics(data));
}

export const UpdateOrgPlanMetrics = (dispatch: any, data: any) => {
    dispatch(updateOrgPlanMetrics(mapToOrgPlanTracker(data)));
}

export const ClearToast = (dispatch: any, id: string) => {
    dispatch(hideToast({ id }))
    setTimeout(() =>
        dispatch(clearToast({ id }))
        , 500);
}

export const LoadSecureDocs = (dispatch: any, id: string) => {
    dispatch(updateLoadingSecureDocs(true));
    SecureDocsService.getSecureDocs(id).then(async (res) => {
        if (res && res.data && res.status === 200) {
            let data = await res.data
            dispatch(updateSecureDocs(data.map(mapToSecureDoc)))
        }
    })
}

export const LoadUsers = (dispatch: any) => {
    const user = UserService.getCurrentUserFromLocalStorage()
    UserService.getAllUsers(user.OrganizationID).then(res => {
        if (res && res.data && res.status === 200) {
            dispatch(updateUsers(res.data?.map(mapToChannelUser)))
        }
    }
    )
}

export const LoadPlans = (dispatch: any) => {
    getAllPlans().then(res => {
        if (res && res.data && res.status === 200) {
            const data = res.data.map(x => x.prices.map((y, index) => mapToNeWPlanModel(x, y)))
            dispatch(setPlans(data.flatMap(x => x)))
        }
    }
    )
}

export const UpdatePlanDetails = (dispatch: any) => {
    UserService.getUserPlanDetails().then(res => {
        if (res.data === "no active plan found") {
            dispatch(updatePlanDetails(mapToUserPlanModel(
                {
                    plan_Id: "",
                    plan_name: "",
                    plan_status: PlanStatus.NO_PLAN,
                    price: "",
                    features: "",
                    features_keys: [],
                    quantity: 0,
                    AddOns: [],
                    recurring: "",
                    monthly: "",
                    yearly: "",
                    plan_created_at: "",
                    plan_updated_at: "",
                    plan_started_at: "",
                    plan_validity: ""
                }
            )))
        }
        else {
            dispatch(updatePlanDetails(mapToUserPlanModel(res.data)))
        }
    }).catch(() => {

        dispatch(updatePlanDetails(mapToUserPlanModel(
            {
                plan_Id: "",
                plan_name: "",
                plan_status: PlanStatus.NO_PLAN,
                price: "",
                features: "",
                features_keys: [],
                quantity: 0,
                AddOns: [],
                recurring: "",
                monthly: "",
                yearly: "",
                plan_created_at: "",
                plan_updated_at: "",
                plan_started_at: "",
                plan_validity: ""
            }
        )))
    })
}

export const LoadAllOrganizations = (dispatch: any) => {
    SysAdminService.getAllOrganizations().then(res => {
        dispatch(updateAllOrganizations(res.data?.map(x => mapToOrganizationModel(x))))
    }
    )
}

export const LoadAllUsers = (dispatch: any) => {
    SysAdminService.getAllUsers().then(res => {
        dispatch(updateAllUsers(res.data?.map(x => mapToChannelUser(x))))
    }
    )
}

export const LoadDasboardDetails = async (dispatch: any) => {
    // dispatch(updateIsLoading(true))
    const docsStatus = await SecureDocsService.getSecureDocsStatus(UserService.getCurrentUserFromLocalStorage().ID)
    if (!!docsStatus) {
        dispatch(updateSecureDocsStatusModel(docsStatus))
    }
    dispatch(updateIsLoading(false))
}

export const LoadSmsNotificationStatus = (dispatch: any) => {
    UserService.getSMSNotificationStatus().then(res => {
        dispatch(updateSmsNotificationStatus(res.data.sms_notification))
    })
}